export interface IFilterData {
  contain: string[];
  exclude: string[];
}

export enum FilterType {
  contain = 'contain',
  exclude = 'exclude'
}
